// extracted by mini-css-extract-plugin
export var calendarView = "_k1-0";